import axios from 'axios';
import { React, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { BodyWrapper, Header, MainWrapper } from '@components';
import { ChevronRightIcon } from '@svgs';

import { MainSidebar } from '../components/MainSidebar/MainSidebar.jsx';
import { DateField } from '@Forms/fields.jsx';
import { fromLocalDate, toLocalDate } from '@Forms/utils.js';

export const AuditLog = () => {
  const { t, i18n } = useTranslation();
  const [isFetching, setIsFetching] = useState(false);
  const {
    handleSubmit,
    control,
    getValues,
    formState: { errors },
  } = useForm({
    mode: 'onBlur',
    defaultValues: { latest_date: fromLocalDate(new Date()) },
  });

  const onSubmit = async (data) => {
    try {
      setIsFetching(true);

      const latest_date = toLocalDate(data.latest_date);
      latest_date.setHours(23, 59, 59, 999);
      const latest_timestamp = latest_date.toISOString();

      const minus_30_date = toLocalDate(data.latest_date);
      minus_30_date.setDate(minus_30_date.getDate() - 30);
      const minus_30_timestamp = minus_30_date.toISOString();

      const csv_data = [];

      // Loop until we run out of data
      let offset = 0;
      const limit = 1000;
      while (true) {
        const response = await axios.get(
          `/api/v2/audits/?timestamp__gt=${minus_30_timestamp}&timestamp__lt=${latest_timestamp}&order_by=-id&offset=${offset}&limit=${limit}`,
          { responseType: 'blob', headers: { Accept: 'application/csv' } },
        );

        if (response.data.size === 0) {
          break;
        }

        offset += limit;
        csv_data.push(response.data);
      }

      const csv = new Blob(csv_data, { type: 'text/csv' });

      let url = URL.createObjectURL(csv);
      let a = document.createElement('a');
      a.href = url;
      a.download = 'audit_log.csv';
      a.click();
      URL.revokeObjectURL(url);
    } catch (error) {
      console.log('Error while fetching', error);
    } finally {
      setIsFetching(false);
    }
  };

  return (
    <>
      <Header />
      <BodyWrapper>
        <MainSidebar />
        <MainWrapper>
          <div className="sb-main-breadcrumbs">
            <ul className="sb-flex">
              <li className="sb-flex">
                <a href="">Audit Log</a>
                <ChevronRightIcon />
              </li>
            </ul>
          </div>
          <div className="sb-manage-content">
            <div className="sb-manage-content-head">
              <h1>{t('Audit Log')}</h1>
              <h2>Up to 30 days before the selected date</h2>
            </div>
            <form
              onSubmit={handleSubmit(onSubmit)}
              className={
                `sb-manage-content-form ` +
                (isFetching ? 'sb-form-disabled' : '')
              }
            >
              <fieldset className="sb-form-item">
                <div className="sb-form-item-inner">
                  <div className="sb-form-item-elements">
                    <Controller
                      control={control}
                      name="latest_date"
                      id="latest_date"
                      render={({ field: controllerField }) => (
                        <DateField
                          error={errors.latest_date}
                          field={controllerField}
                          helpText=""
                          label="Latest Date"
                          value={getValues('latest_date')}
                        />
                      )}
                    />
                  </div>
                </div>
              </fieldset>
              <button
                type="submit"
                className="sb-btn sb-btn-save"
                disabled={isFetching}
              >
                Download CSV
              </button>
            </form>
          </div>
        </MainWrapper>
      </BodyWrapper>
    </>
  );
};
